<template>
    <div class="animated fadeIn">
        <b-container fluid class="p-0" v-if="$hasPermission([0, 1, 2, 3, 4, 5, 6, 7, 9, 10, 11, 12])">
            <b-row>
                <b-col cols="12" sm="6" md="3">
                    <b-card
                            class="cursor-pointer"
                            bg-variant="primary"
                            :class="ReportType === 'SUBTOTAL' ? 'shadow-lg' : ''"
                            style="padding-top: 0.1rem"
                            @click="getChart($store.state.selectedRestaurantId, Passed_Date, 'SUBTOTAL', 'Sales')"
                    >
                        <b-card-text>
                            <!--              <p>9.823</p>-->
                            <p class="mb-0" style="font-size: 0.75rem;">Net Sales (Sales after credit & refund, before tax/tip/fees)</p>
                            
                        </b-card-text>
                    </b-card>
                </b-col>
                <b-col cols="12" sm="6" md="3">
                    <b-card
                            class="cursor-pointer tax-card"
                            :class="ReportType === 'TAX' ? 'shadow-lg' : ''"
                            @click="getChart($store.state.selectedRestaurantId, Passed_Date, 'TAX', 'Tax')">
                        <b-card-text>
                            <!--              <p>9.823</p>-->
                            <p class="mb-0">Tax</p>
                        </b-card-text>
                    </b-card>
                </b-col>
                <b-col cols="12" sm="6" md="3">
                    <b-card
                            class="cursor-pointer tip-card"
                            :class="ReportType === 'TIP' ? 'shadow-lg' : ''"
                            @click="getChart($store.state.selectedRestaurantId, Passed_Date, 'TIP', 'Tip')">
                        <b-card-text>
                            <!--              <p>9.823</p>-->
                            <p class="mb-0">Tip</p>
                        </b-card-text>
                    </b-card>
                </b-col>
                <b-col cols="12" sm="6" md="3">
                    <b-card
                            class="cursor-pointer restaurant-total-card"
                            :class="ReportType === 'RESTAURANTTOTAL' ? 'shadow-lg' : ''"
                            @click="getChart($store.state.selectedRestaurantId, Passed_Date, 'RESTAURANTTOTAL', 'Restaurant Total Payment Collected & Refunded')">
                        <b-card-text >
                            <!--              <p>9.823</p>-->
                            <p class="mb-0">Restaurant Total Payment Collected & Refunded</p>
                        </b-card-text>
                    </b-card>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-card no-body>
                        <b-card-header>
                            <b-container class="px-0" fluid>
                                <b-row class="align-items-center justify-content-between">
                                    <b-col cols="12" lg="9" class="mb-3 mb-lg-0">
                                        <div class="text-wrap">
                                            Note: Subtotal, Tax, Tip and Restaurant Total Payment Collected data include tab orders with "Paid" condition only ("canceled" and "unpaid" tabs are excluded).
                                        </div>
                                        
                                    </b-col>
                                    <b-col cols="12" lg="3" class="d-flex flex-row justify-content-end">
                                        <b-btn size="lg" class="btn btn-dark px-3 mr-2" @click="fetch(Passed_Date, exportDate)">
                                            <font-awesome-icon icon="download"/>
                                        </b-btn>
                                        <b-button-group size="lg">
                                            <b-button
                                                    :class="Passed_Date === 12 ? 'activeBtn' : 'deactiveBtn'"
                                                    @click="getChart($store.state.selectedRestaurantId, 12, ReportType, title)">12m</b-button>
                                            <b-button
                                                    :class="Passed_Date === 30 ? 'activeBtn' : 'deactiveBtn'"
                                                    @click="getChart($store.state.selectedRestaurantId, 30, ReportType, title)">30d</b-button>
                                            <b-button
                                                    :class="Passed_Date === 7 ? 'activeBtn' : 'deactiveBtn'"
                                                    @click="getChart($store.state.selectedRestaurantId, 7, ReportType, title)">7d</b-button>
                                        </b-button-group>
                                    </b-col>
                                </b-row>
                            </b-container>
                        </b-card-header>
                        <b-card-body>
                            <div class="text-wrap d-flex flex-row justify-content-center">
                                ("canceled" and "unpaid" tabs are excluded)                                        </div>
                            <BarChart v-if="render" legends="" prefixLabel="$" :series="series" :categories="categories" :titleChart="title"/>
                        </b-card-body>
                    </b-card>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
    import moment from 'moment'
    import BarChart from './barChart'
    export default {
        name: 'Dashboard',
        components: {BarChart},
        component: {
            BarChart
        },
        created() {
        },
        watch: {
            '$store.state.selectedRestaurantId': {
                handler: function (newVal) {
                    //View charts of selected restaurants based on 4 parameters
                    if (newVal !== null) {
                        this.getChart(newVal, this.Passed_Date, this.ReportType, this.title)
                    }
                },
                immediate: true
            }
        },
        data () {
            return {
                Passed_Date: 7,
                ReportType: 'SUBTOTAL',
                series: [],
                categories: [],
                title: 'Net Sales',
                render: false,
                stats: [],

                json_fields: {
                    'Date': {
                        field: 'PaymentDate',
                        callback: (value) => {return moment(value).format('D - MMM - YY')}
                    },
                    'Sales (excluding tax & tip)': {
                        field: 'Subtotal',
                        callback: (value) => {return '$' + value.toFixed(2)}
                    },
                    'total tax': {
                        field: 'Tax',
                        callback: (value) => {return '$' + value.toFixed(2)}
                    },
                    'alcohol tax': {
                        field: 'Tax_Alc',
                        callback: (value) => {return '$' + value.toFixed(2)}
                    },
                    'non-alcohol tax': {
                        field: 'Tax_Non_Alc',
                        callback: (value) => {return '$' + value.toFixed(2)}
                    },
                    'Tip': {
                        field: 'Tip',
                        callback: (value) => {return '$' + value.toFixed(2)}
                    },
                    'Restaurant Total': {
                        field: 'RestaurantTotal',
                        callback: (value) => {return '$' + value.toFixed(2)}
                    },
                    'Refund': {
                        field: 'Refund',
                        callback: (value) => {return '$' + value.toFixed(2)}
                    },
                },
                exportDate: null
            }
        },
        metaInfo () {
            return {
                title: 'Sales Insights'
            }
        },
        
        mounted () {
            // this.getChart(this.$store.state.selectedRestaurantId, this.Passed_Date, this.ReportType, this.title)
        },
        methods: {
            dynamicNameFileByPassedDate (Passed_Date, exportDate) {
                if (Passed_Date === 12) {
                    return 'Financials_' + Passed_Date + 'm'+ '_' + exportDate
                } else {
                    return 'Financials_' + Passed_Date + 'd'+ '_' + exportDate
                }
            },
            getChart (RestaurantID, Passed_Date, ReportType, Title) {
                let obj = {
                    RestaurantID,
                    // UserID: localStorage.getItem('userID'),
                    Passed_Date,
                    ReportType
                }
                this.render = false
                this.title = Title
                this.ReportType = ReportType
                this.Passed_Date = Passed_Date
                this.series = []
                this.categories = []
                this.$api.getRestaurant.GetRestaurantDashboardStats1(obj).then(res => {
                    if (res.success) {
                        let result = res.results.Stats1
                        this.stats = result
                        if (result.length) {
                            let data = []
                            moment.locale('en');
                            //Prepare Series data based on report type
                            if (ReportType === 'TIP') {
                                result.forEach(item => {
                                    if (Passed_Date === 12) {
                                        this.categories.push(moment(item.PaymentDate).format('MMM YY'))
                                    } else {
                                        this.categories.push(moment(item.PaymentDate).format('MMM D'))
                                    }
                                    data.push(item.Tip)
                                })
                                this.series.push({
                                    name: Title,
                                    color: 'rgb(185,122,87)',
                                    data
                                })
                                this.render = true
                            }
                            else if (ReportType === 'TAX') {
                                result.forEach(item => {
                                    if (Passed_Date === 12) {
                                        this.categories.push(moment(item.PaymentDate).format('MMM YY'))
                                    } else {
                                        this.categories.push(moment(item.PaymentDate).format('MMM D'))
                                    }
                                })
                                this.renderTax(result)
                                this.renderAlcoholTax(result)
                                this.renderNonAlcoholTax(result)
                                this.render = true
                            }
                            else if (ReportType === 'SUBTOTAL') {
                                result.forEach(item => {
                                    if (Passed_Date === 12) {
                                        this.categories.push(moment(item.PaymentDate).format('MMM YY'))
                                    } else {
                                        this.categories.push(moment(item.PaymentDate).format('MMM D'))
                                    }
                                    data.push(item.Subtotal)
                                })
                                this.series.push({
                                    name: Title,
                                    color: '#20a8d8',
                                    data
                                })
                                this.render = true
                            }
                            else if (ReportType === 'RESTAURANTTOTAL') {
                                result.forEach(item => {
                                    if (Passed_Date === 12) {
                                        this.categories.push(moment(item.PaymentDate).format('MMM YY'))
                                    } else {
                                        this.categories.push(moment(item.PaymentDate).format('MMM D'))
                                    }
                                })
                                this.renderRestaurantTotal(result)
                                this.renderRefund(result)
                                // this.series.push({
                                //     name: Title,
                                //     color: '#66bb6a',
                                //     data
                                // })
                                this.render = true
                            }
                        }
                        else {
                            this.stats = []
                        }

                    } else {
                        this.$showError(res.message)
                    }
                })
            },
            renderNonAlcoholTax (result) {
                let values = []
                result.forEach((item) => {
                    values.push(item.Tax_Non_Alc)
                })
                this.series.push({
                    name: 'Non-Alcohol',
                    data: values,
                    color: 'rgb(195,195,195)'
                })
            },
            renderAlcoholTax (result) {
                let values = []
                result.forEach((item) => {
                    values.push(item.Tax_Alc)
                })
                this.series.push({
                    name: 'Alcohol',
                    data: values,
                    color: 'rgb(127,127,127)'
                })
            },
            renderRefund (result) {
                let values = []
                result.forEach((item) => {
                    values.push(item.Refund)
                })
                this.series.push({
                    name: 'Refund',
                    data: values,
                    color: '#f06292'
                })
            },
            renderRestaurantTotal (result) {
                let values = []
                result.forEach((item) => {
                    values.push(item.RestaurantTotal)
                })
                this.series.push({
                    name: 'Restaurant Total Payment Collected',
                    data: values,
                    color: '#66bb6a'
                })
            },
            renderTax (result) {
                let values = []
                result.forEach((item) => {
                    values.push(item.Tax)
                })
                this.series.push({
                    name: 'Total',
                    data: values,
                    color: 'rgb(64,0,64)'
                })
            },
            showItemByClinetTypeID (permissions) {
                //permission component
                //Using this function, we hide the chart from the kds user
                let allowed = false
                let getCurrentUserClient = localStorage.getItem('ClientTypeID')
                let find = permissions.filter(item => item === +getCurrentUserClient)
                if (find.length) {
                    allowed = true
                } else {
                    allowed = false
                }
                return allowed
            },
            fetch (Passed_Date, exportDate) {
                //get csv file
                let obj = {
                    RestaurantID: this.$store.state.selectedRestaurantId,
                    // UserID: localStorage.getItem('userID'),
                    Passed_Date: this.Passed_Date,
                    ReportType: 'ALL'
                }
                return this.$api.getRestaurant.GetRestaurantDashboardStats1(obj).then(res => {
                    if (res.success) {
                        this.exportDate = moment().format('MMDDYYYY')
                        res.results.Stats1.forEach(item => {
                            item.RestaurantTotal = Number(item.Subtotal) + Number(item.Tax) + Number(item.Tip)
                        })
                        const fileName = this.dynamicNameFileByPassedDate(Passed_Date, this.exportDate)
                        this.jsonToCSV(res.results.Stats1, fileName, true)
                        return res.results.Stats1
                    } else {
                        this.$showError(res.message)
                    }
                })
            },
            jsonToCSV (JSONData, ReportTitle, ShowLabel) {
                //If JSONData is not an object then JSON.parse will parse the JSON string in an Object
                var arrData = typeof JSONData != 'object' ? JSON.parse(JSONData) : JSONData;
                //Set Report title in first row or line
                var CSV = ReportTitle + '\n';
                if (ShowLabel) {
                    var row = "";
                    let staticCol = ['Date', 'Sales (excluding tax & tip)', 'total tax', 'alcohol tax','non-alcohol tax','Tip','Restaurant Total','Refund', 'Delivery Fee']
                    let allCol = staticCol
                    //This loop will extract the label from 1st index of on array
                    for (var index in allCol) {

                        //Now convert each value to string and comma-seprated
                        row += allCol[index] + ',';
                    }

                    row = row.slice(0, -1);

                    //append Label row with line break
                    CSV += row + '\n';
                }
                let dataRow = []
                arrData.forEach((item, index) => {
                    let obj = {
                        PaymentDate: moment(item.PaymentDate).format('D - MMM - YY'),
                        Subtotal: '$' + item.Subtotal.toFixed(2),
                        Tax: '$' + item.Tax.toFixed(2),
                        Tax_Alc: '$' + item.Tax_Alc.toFixed(2),
                        Tax_Non_Alc: '$' + item.Tax_Non_Alc.toFixed(2),
                        Tip: '$' + item.Tip.toFixed(2),
                        RestaurantTotal: '$' + item.RestaurantTotal.toFixed(2),
                        Refund: '$' + item.Refund.toFixed(2),
                        Delivery_Fee: '$' + item.Delivery_Fee.toFixed(2),
                    }
                    dataRow.push(obj)
                })
                for (var i = 0; i < dataRow.length; i++) {
                    var row = "";
                    //2nd loop will extract each column and convert it in string comma-seprated
                    for (var index in dataRow[i]) {
                        row += '"' + dataRow[i][index] + '",';
                    }
                    row.slice(0, row.length - 1);
                    //add a line break after each row
                    CSV += row + '\n';
                }

                if (CSV == '') {
                    alert("Invalid data");
                    return;
                }

                var fileName = ReportTitle;
                //this will remove the blank-spaces from the title and replace it with an underscore
                // fileName += ReportTitle.replace(/ /g,"");

                //Initialize file format you want csv or xls
                var uri = 'data:text/csv;charset=utf-8,%EF%BB%BF,' + encodeURI(CSV);

                // Now the little tricky part.
                // you can use either>> window.open(uri);
                // but this will not work in some browsers
                // or you will not get the correct file extension

                //this trick will generate a temp <a /> tag
                var link = document.createElement("a");
                link.href = uri;

                //set the visibility hidden so it will not effect on your web-layout
                link.style = "visibility:hidden";
                link.download = fileName + ".csv";

                //this part will append the anchor tag and remove it after automatic click
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

            }
        }
    }
</script>
<style scoped>
    .activeBtn {
        background: #f5c31d !important;
        border-color: #c8ced3 !important;
        font-weight: bold;
    }
    .deactiveBtn {
        background: #fff !important;
        border-color: #c8ced3 !important;
        color: #c8ced3 !important;
        font-weight: bold;
    }
    .tax-card{
        background: rgb(64,0,64) !important;
        color: #fff;
    }
    .tip-card{
        background: rgb(185,122,87) !important;
        color: #fff;
    }
    .restaurant-total-card{
        background: #66bb6a;
        color: #fff;
    }
</style>
